export function Header() {
  return (
    <header className="site-header">
      <div className="container site-header__bar">
        <p className="site-header__title">
          <strong>JWT Misconfiguration Lab</strong>
        </p>
        <a className="privacy-pill" href="#privacidad">
          Privacidad: procesamiento 100% local
        </a>
      </div>
    </header>
  )
}
